module.exports = __webpack_public_path__ + "whitelungs.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitelungs.png
// module id = 894
// module chunks = 0